import { gql } from '@apollo/client';

const TransactionState = gql`
  query TransactionStateQuery($language: Language, $testmode: Boolean) {
    user(language: $language, testmode: $testmode) {
      id
      cart {
        id
        state
      }
    }
  }
`;

export default TransactionState;
